var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowRight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6.797,
  height: 11.536,
  viewBox: "0 0 6.797 11.536",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "round-keyboard_arrow_right-24px",
  d: "M9.3,16.185,13.3,12.18,9.3,8.175a1.029,1.029,0,1,1,1.455-1.455l4.738,4.738a1.028,1.028,0,0,1,0,1.455l-4.738,4.738a1.028,1.028,0,0,1-1.455,0A1.05,1.05,0,0,1,9.3,16.185Z",
  transform: "translate(-8.997 -6.418)",
  fill: "#545454"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_arrow_right.ffb01044.svg";
export { ForwardRef as ReactComponent };